import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Leaf } from "lucide-react";
import { api } from "@/lib/api";
import { useContent } from "@/lib/content";
import SocialLinks from "@/components/SocialLinks";

const PAGES = [
  { to: "/about", label: "About Us" },
  { to: "/appointments", label: "Appointments" },
  { to: "/shop", label: "Buy Now" },
  { to: "/yoga", label: "21-Day Yoga" },
  { to: "/garbhsanskar", label: "Garbhsanskar" },
  { to: "/retreats", label: "Natural Retreat" },
  { to: "/track", label: "Track Order" },
];

const LEGAL = [
  { to: "/legal/privacy", label: "Privacy Policy" },
  { to: "/legal/terms", label: "Terms & Conditions" },
  { to: "/legal/refund", label: "Refund & Cancellation" },
];

export default function SiteFooter() {
  const { c } = useContent();
  const [settings, setSettings] = useState({});

  useEffect(() => { api.get("/settings").then(({ data }) => setSettings(data)).catch(() => {}); }, []);
  const wa = (settings.whatsapp_number || "").replace(/\D/g, "");

  return (
    <footer className="border-t border-border bg-background" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-14 grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <span className="w-8 h-8 rounded-full bg-primary text-primary-foreground flex items-center justify-center"><Leaf size={15} /></span>
            <span className="font-display text-xl">{settings.clinic_name || "Immortal Vedas"}</span>
          </div>
          <p className="text-sm text-muted-foreground max-w-sm leading-relaxed whitespace-pre-line" data-testid="footer-tagline">
            {c("footer.tagline")}
          </p>
          {c("footer.address") && (
            <p className="text-xs text-muted-foreground mt-4 whitespace-pre-line" data-testid="footer-address">{c("footer.address")}</p>
          )}
          {wa && (
            <a
              href={`https://wa.me/${wa}`}
              target="_blank"
              rel="noreferrer"
              className="text-xs text-primary hover:underline mt-3 inline-block"
              data-testid="footer-whatsapp"
            >
              WhatsApp us on {settings.whatsapp_number}
            </a>
          )}
          <SocialLinks settings={settings} />
        </div>

        <div>
          <div className="overline mb-4">Explore</div>
          <ul className="space-y-2">
            {PAGES.map((p) => (
              <li key={p.to}>
                <Link to={p.to} className="text-sm text-muted-foreground hover:text-primary" data-testid={`footer-link-${p.to.replace(/\//g, "")}`}>
                  {p.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="overline mb-4">Legal</div>
          <ul className="space-y-2">
            {LEGAL.map((p) => (
              <li key={p.to}>
                <Link to={p.to} className="text-sm text-muted-foreground hover:text-primary" data-testid={`footer-legal-${p.to.split("/").pop()}`}>
                  {p.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-border py-6 text-center text-xs text-muted-foreground" data-testid="footer-note">
        {c("footer.note")}
      </div>
    </footer>
  );
}
